module.exports = __webpack_public_path__ + "img/map.6bf85b0c.svg";